<template>
    <section class="admin-dashboard-hero-section p-4 sm:px-6 sm:py-5 md:px-8 md:py-6">
        <div class="text-xl sm:text-2xl md:text-[24px] text-gray-900 font-bold">Engagement Statistics</div>
        <p class="text-sm sm:text-base text-gray-500">Lorem ipsum dolor sit amet consectetur.</p>

        <!-- First Row: Equal Width Cards - Stack on small screens -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-4 sm:mt-6">
            <div class="w-full">
                <TotalTrainingHours />
            </div>
            <div class="w-full">
                <VisitDuration />
            </div>
            <div class="w-full sm:col-span-2 lg:col-span-1">
                <ConsultingHours />
            </div>
        </div>

        <!-- Second Row: Progressive layout changes -->
        <div class="grid grid-cols-1 gap-4 sm:gap-6 mt-4 sm:mt-6">
            <!-- Mobile: Stack all components -->
            <div class="sm:hidden">
                <div class="mb-4">
                    <MobileAppLogins />
                </div>
                <div class="mb-4">
                    <EmployeeCompletion />
                </div>
                <div>
                    <DailyVisit />
                </div>
            </div>

            <!-- Tablet and up: Use grid layout -->
            <div class="hidden sm:flex sm:flex-wrap xl:flex-nowrap sm:gap-6">
                <!-- MobileAppLogins: Takes full width on small screens, 1/3 width on large screens, 1/6 on xl -->
                <div class="sm:w-full md:w-full lg:w-1/3 xl:w-1/6 mb-6 sm:mb-0">
                    <MobileAppLogins />
                </div>
                
                <!-- EmployeeCompletion: Takes full width on small screens, 1/3 width on large screens, 2/6 on xl -->
                <div class="sm:w-full md:w-full lg:w-1/3 xl:w-2/6 mb-6 sm:mb-0">
                    <EmployeeCompletion />
                </div>
                
                <!-- DailyVisit: Takes full width on small screens, 1/3 width on large screens, 3/6 on xl -->
                <div class="sm:w-full md:w-full lg:w-1/3 xl:w-3/6 mb-6 sm:mb-0">
                    <DailyVisit />
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import TotalTrainingHours from "./TotalTranningHours.vue";
import VisitDuration from "./VisitDuration.vue";
import ConsultingHours from "./ConsultingHours.vue";
import MobileAppLogins from "./MobileAppLogins.vue";
import EmployeeCompletion from "./UniqueEmployee.vue";
import DailyVisit from "./DailyVisit.vue";

export default {
    name: "Dashboard",
    components: {
        TotalTrainingHours,
        VisitDuration,
        ConsultingHours,
        MobileAppLogins,
        EmployeeCompletion,
        DailyVisit,
    },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/admin/dashboard1/Dashboard.vue